var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockUnlockWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lock-unlock",
    transform: "translate(-6 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13033",
    "data-name": "Group 13033",
    transform: "translate(6 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12979",
    "data-name": "Path 12979",
    d: "M23.778,8.857H21.556a4.446,4.446,0,1,0-8.889,0v3.429h10A3.382,3.382,0,0,1,26,15.714v6.857A3.382,3.382,0,0,1,22.667,26H9.333A3.382,3.382,0,0,1,6,22.571V15.714a3.382,3.382,0,0,1,3.333-3.429h1.111V8.857A6.764,6.764,0,0,1,17.111,2a6.764,6.764,0,0,1,6.667,6.857Zm-1.111,5.714H9.333a1.127,1.127,0,0,0-1.111,1.143v6.857a1.127,1.127,0,0,0,1.111,1.143H22.667a1.127,1.127,0,0,0,1.111-1.143V15.714A1.127,1.127,0,0,0,22.667,14.571Z",
    transform: "translate(-6 -2)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockUnlockWhite);
export default __webpack_public_path__ + "static/media/lock-unlock-white.f79c4c27636a1a18b5192adc6297437a.svg";
export { ForwardRef as ReactComponent };